import validate from "./generated-validator.cjs";
export { journalSchema } from "./schema-definition.js";
export function validateShape(value) {
  if (!validate(value))
    throw new Error(
      "Journal validation failed: " +
        validate.errors
          .map((e) => `${e.instancePath || "/"} ${e.message}`)
          .join("; "),
    );
  return value;
}
